import React, { useState } from 'react'
import styles from "./NewInvoicePopup.module.css"
import CustomTextarea from 'Common/CustomTextArea'
import CopyToClipboard from 'Common/CopyToClipboard '

const NewInvoicePopup = ({ heading, subHeading, reasonBox, onConfirm, onCancel, buttonTitle, cancelButtonTitle, patientData }) => {
    const [reason, setReason] = useState("")
    return (
        <div className={styles.darkBG}   >
            <div className={styles.centered}>
                <div className={styles.modal}>
                    <div className="flex items-center justify-between">
                        <h5 className=" text-[18px] font-semibold text-center w-full text-orange-400">Invoice Expired !</h5>
                        <button
                            onClick={onCancel}
                            className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2"
                        >
                            <img src="/img/crossblack.svg" alt="cross" />
                        </button>
                    </div>

                    {/* <button className={styles.closeBtn} onClick={onCancel}>x</button> */}
                    <pre style={{ fontFamily: '"Open Sans", sans-serif' }} className={styles.modalContent}>
                        {subHeading ? <p className={styles.subHeading}>{patientData.message}</p> : <p className='flex flex-col'> {patientData.message}
                            <div className='flex flex-col items-start mt-3'>
                                <span className='font-semibold'>Your new invoice number:</span>
                                <span className='relative w-full p-2 text-lg font-semibold text-green-500 bg-gray-100 rounded-md'>
                                    {/* <span className='absolute right-0 text-sm text-gray-800 -top-6'> click to copy</span> */}
                                    <CopyToClipboard textToCopy={patientData.patient?.newInvoiceNumber}  >  {patientData.patient?.newInvoiceNumber}</CopyToClipboard>
                                </span>
                            </div>
                        </p>}
                        {reasonBox && <CustomTextarea value={reason} onChange={(e) => setReason(e.target.value)} rows="5" extraClass={`${styles.modeltextare} outline-none mt-1  `} />}
                    </pre>
                    <div className={styles.modalActions} >
                        <div className={styles.actionsContainer}>
                            {/* <CustomButtonNew text={cancelButtonTitle ? cancelButtonTitle : 'Cancel'} type={"outline"} onClick={onCancel} /> */}
                            {/* <CustomButtonNew text={buttonTitle ? buttonTitle : "Delete"} className={styles.deleteBtn} extraClass={'ml-3'} onClick={() => onConfirm(reason)}></CustomButtonNew> */}
                            {/* <button className={styles.cancelBtn} onClick={onCancel}></button> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewInvoicePopup
